import * as React from 'react';

import { CircularProgress, Typography } from '@emburse/ui-core';

type LoadingStateProps = {
  caption?: string;
};

const LoadingState = ({ caption }: LoadingStateProps) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <CircularProgress color="primary" variant="indeterminate" />
      {caption && <Typography variant="h6">{caption}</Typography>}
    </div>
  );
};

export { LoadingState };
